
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-mieten/[offerId]",
      function () {
        return require("private-next-pages/fotobox-mieten/[offerId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-mieten/[offerId]"])
      });
    }
  